import { getCountries, getCountryCallingCode, parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

const names = new Intl.DisplayNames(['en'], { type: 'region' });
export function countryName(country = 'IN') { return names.of(country) || country; }
const countries = getCountries().sort((a, b) => a === 'IN' ? -1 : b === 'IN' ? 1 : countryName(a).localeCompare(countryName(b)));

export function possibleContactPhone(value: string, country: CountryCode, optional = false) {
  if (!value.trim()) return optional;
  if (!/^\+?[\d\s().-]+$/.test(value.trim())) return false;
  const phone = parsePhoneNumberFromString(value, { defaultCountry: country, extract: false });
  return Boolean(phone?.isPossible() && phone.countryCallingCode === getCountryCallingCode(country) && (!phone.country || phone.country === country));
}
export function nationalPhone(value: string, country: CountryCode) {
  return parsePhoneNumberFromString(value, { defaultCountry: country, extract: false })?.nationalNumber.toString() || value;
}

export function CountryPhoneInput({ country, phone, onCountry, onPhone, optional = false, disabled = false }: {
  country: CountryCode; phone: string; onCountry: (country: CountryCode) => void; onPhone: (phone: string) => void; optional?: boolean; disabled?: boolean;
}) {
  const code = getCountryCallingCode(country);
  function changePhone(value: string) {
    const clean = value.replace(/[^\d+\s().-]/g, '').slice(0, 24);
    if (clean.startsWith('+')) {
      const parsed = parsePhoneNumberFromString(clean, { extract: false });
      if (parsed?.country && parsed.isPossible()) { onCountry(parsed.country); onPhone(parsed.nationalNumber.toString()); return; }
    }
    onPhone(clean);
  }
  return <div className="country-phone-fields">
    <label>Country<select value={country} onChange={event => onCountry(event.target.value as CountryCode)} disabled={disabled} autoComplete="country">{countries.map(item => <option key={item} value={item}>{countryName(item)} (+{getCountryCallingCode(item)})</option>)}</select></label>
    <label>Phone number{optional && <span className="phone-optional"> (optional)</span>}<div className="country-phone-number"><span>+{code}</span><input type="tel" inputMode="tel" autoComplete="tel-national" aria-label={`Phone number, country code +${code}`} value={phone} onChange={event => changePhone(event.target.value)} maxLength={24} placeholder="Your phone number" disabled={disabled} aria-invalid={phone.trim() ? !possibleContactPhone(phone, country) : undefined} /></div></label>
    {phone.trim() && !possibleContactPhone(phone, country) && <small className="phone-validation" role="status">Enter a complete phone number for {countryName(country)}.</small>}
  </div>;
}
export type { CountryCode };
